import { isUnderTest } from "$lib/experiments/routes";

// Prices are the same for every visitor and change only when the product's
// price does, so the page is built once at build time. Client rendering is left
// on, as on the home page, so the top bar can still swap in the cabinet link
// for a visitor who already has a session.
//
// EXCEPT WHILE AN EXPERIMENT IS RUNNING ON IT. A file written once and served
// to everybody cannot carry a per-visitor variant: the only way to show one
// visitor a different version would be to change the page after it arrived,
// which is the flash that makes a test measure the flash as much as the change.
// So the build that starts an experiment here renders the page per request
// instead, and the build that ends it puts the file back
// (lib/experiments/routes.ts).
export const prerender = !isUnderTest("/pricing");
